/**
 * @generated SignedSource<<0eafda4282a9201a46e961b587814c07>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type WebhookSubscriptionType = "DATADOG" | "FIREHYDRANT" | "INCIDENT_IO" | "OPSGENIE" | "PAGERDUTY" | "ROOTLY" | "SLACK" | "%future added value";
export type CreateOrUpdateWebhookSubscriptionInput = {
  webhookConfigs: ReadonlyArray<WebhookSubscriptionConfigInput>;
  webhookSubscriptionType: WebhookSubscriptionType;
};
export type WebhookSubscriptionConfigInput = {
  id?: any | null | undefined;
  name: string;
  opsgenieApiKey?: string | null | undefined;
  remoteId: string;
  secret: string;
};
export type IncidentIoIntegrationCreateOrUpdateWebhookSubscriptionMutation$variables = {
  input: CreateOrUpdateWebhookSubscriptionInput;
};
export type IncidentIoIntegrationCreateOrUpdateWebhookSubscriptionMutation$data = {
  readonly createOrUpdateWebhookSubscription: {
    readonly error: string | null | undefined;
    readonly webhookSubscriptions: ReadonlyArray<{
      readonly id: any;
      readonly name: string;
      readonly remoteId: string;
    }> | null | undefined;
  };
};
export type IncidentIoIntegrationCreateOrUpdateWebhookSubscriptionMutation = {
  response: IncidentIoIntegrationCreateOrUpdateWebhookSubscriptionMutation$data;
  variables: IncidentIoIntegrationCreateOrUpdateWebhookSubscriptionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateOrUpdateWebhookSubscriptionPayload",
    "kind": "LinkedField",
    "name": "createOrUpdateWebhookSubscription",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLWebhookSubscription",
        "kind": "LinkedField",
        "name": "webhookSubscriptions",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "remoteId",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IncidentIoIntegrationCreateOrUpdateWebhookSubscriptionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IncidentIoIntegrationCreateOrUpdateWebhookSubscriptionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b6d8c35c14919c64d24aa1c8c257fcd1",
    "id": null,
    "metadata": {},
    "name": "IncidentIoIntegrationCreateOrUpdateWebhookSubscriptionMutation",
    "operationKind": "mutation",
    "text": "mutation IncidentIoIntegrationCreateOrUpdateWebhookSubscriptionMutation(\n  $input: CreateOrUpdateWebhookSubscriptionInput!\n) {\n  createOrUpdateWebhookSubscription(input: $input) {\n    webhookSubscriptions {\n      id\n      name\n      remoteId\n    }\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "d1fed8d09cde1c240f13887bc1d76281";

export default node;
